// extracted by mini-css-extract-plugin
export default {"openedDrawer":"MenuDrawer_openedDrawer__V6KHG","closedDrawer":"MenuDrawer_closedDrawer__pNeQq","spaceQuoteGroup":"MenuDrawer_spaceQuoteGroup__E3wWW"};